import React from 'react';
import '../../assets/css/store/product_filter.css';

const ProductFilter = ({ categories, selected, onSelect }) => {
    return (
        <div className="product-filter">
            <h3>Categories</h3>
            <ul className="category-list">
                {categories.map(category => (
                    <li 
                        key={category.id}
                        className={`category-item ${selected === category.id ? 'active' : ''}`}
                        onClick={() => onSelect(category.id)}
                    >
                        {category.name}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductFilter;